import React, { ChangeEvent } from 'react';
import zipcodes from 'zipcodes';
import { Col, Form, Layout, Row, Typography } from 'antd';
import { CityAutoSuggest, Input, Select } from 'components';
import { useLang } from '../PlayerRegistration';
import './style.scss';

const formatStates = (state: string) =>
  state
    .toLowerCase()
    .split(' ')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');

export const states = Object.entries(zipcodes.states.abbr).map(([value, label]) => ({
  label: formatStates(label),
  value,
}));

export const Step4 = () => {
  const { t } = useLang();
  const form = Form.useFormInstance();

  const handleZipChange = (e: ChangeEvent<HTMLInputElement>) => {
    const zip = e.target.value;
    if (zip.length === 5) {
      const location = zipcodes.lookup(zip);
      if (location) {
        form.setFieldsValue({
          city: location.city,
          state: location.state,
        });
      }
    }
  };

  return (
    <Layout className="player-registration__step-4">
      <Row className="step-header">
        <Col span={24}>
          <Typography.Title level={4}>{t('subtitle_step_4')}</Typography.Title>
        </Col>
        <Col span={24}>
          <Typography.Text>{t('description_step_4')}</Typography.Text>
        </Col>
      </Row>
      <Row gutter={8}>
        <Col span={24} md={{ flex: '1' }}>
          <Input
            maxLength={50}
            name="address1"
            label={t('label_address')}
            rules={[{ required: true, message: t('error_address') }]}
          />
        </Col>
        <Col span={24} md={{ flex: '1' }}>
          <Input maxLength={50} name="address2" label={t('label_apartment')} />
        </Col>
      </Row>
      <Row gutter={8}>
        <Col flex="72px">
          <Input
            maxLength={5}
            name="zip"
            label={t('label_zip')}
            rules={[
              { required: true, message: t('error_zip') },
              {
                pattern: /^\d{5}$/,
                message: t('error_zip_5'),
              },
            ]}
            onChange={handleZipChange}
          />
        </Col>
        <Col sm={24} md={{ flex: '1' }}>
          <CityAutoSuggest name="city" label={t('label_city')} rules={[{ required: true, message: t('error_city') }]} />
        </Col>
        <Col sm={24} md={{ flex: '1' }}>
          <Select
            name="state"
            label={t('label_state')}
            rules={[{ required: true, message: t('error_state') }]}
            options={states}
          />
        </Col>
      </Row>
    </Layout>
  );
};
